export default function TestModeBanner() {
  return (
    <div className="w-full bg-red-600 text-white px-4 py-3 text-center font-bold text-lg">
      <span aria-hidden="true">⚠</span> TEST MODE ACTIVE. TEST API KEY AUTHENTICATION IS ENABLED. DO NOT USE IN PRODUCTION.
    </div>
  );
}
